(function () {
  'use strict';

  var {slideUp, slideDown} = domSlider;

  /**
   * Main functionality should be in an 'init' function
   **/
  var initListingCardsPrograms = function () {
    var container = this;

    var $accordionBtn = container.querySelectorAll('.accordion-trigger');
    var TRANSITION_TIME = 50;

    $accordionBtn.forEach(function (el) {
      el.addEventListener('click', function () {

        var self = this;
        var $target = self.nextElementSibling;

        // open/close next() accordion
        if (!$target.classList.contains('active')) {
          // close
          $accordionBtn.forEach(function (el) {
            el.setAttribute('aria-expanded', 'false');
            el.classList.remove('open');
            el.nextElementSibling.classList.remove('active');
            slideUp({element: el.nextElementSibling, slideSpeed: TRANSITION_TIME});
          })
          // open
          $target.classList.add('active');
          slideDown({element: $target, slideSpeed: TRANSITION_TIME});
          self.setAttribute('aria-expanded', 'true');
        }

        // toggle button
        if (self.classList.contains('open')) {
          // close accordion
          self.classList.remove('open');
          $target.classList.remove('active');
          slideUp({element: $target, slideSpeed: TRANSITION_TIME});
          self.setAttribute('aria-expanded', 'false');
        } else {
          // open accordion
          self.classList.add('open');
          $target.classList.add('active');
          slideDown({element: $target, slideSpeed: TRANSITION_TIME});
          self.setAttribute('aria-expanded', 'true');
        }
      });
    })

    // accessibility
    container.addEventListener('keydown', function (e) {
      // home key
      if (e.keyCode === 36) {
        e.preventDefault();
        $accordionBtn[0].focus();
      }

      // end key
      if (e.keyCode === 35) {
        e.preventDefault();
        $accordionBtn[$accordionBtn.length - 1].focus();
      }
    });
  };

  /**
   * This is boilerplate: add a behavior to window.DP.behaviors
   **/
  window.DP.behaviors.listingCardsPrograms = {
    attach: function (context) {
      context.querySelectorAll('.cc--listing-cards-programs:not(.listingCardsPrograms)').forEach(function (node) {
        node.classList.add('listingCardsPrograms');
        initListingCardsPrograms.apply(node);
      });
    }
  };

}());
